var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgAward = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95487 14.0986C6.16267 12.7776 5 10.652 5 8.25479C5 4.24808 8.24808 1 12.2548 1C16.2615 1 19.5096 4.24808 19.5096 8.25479C19.5096 10.6515 18.3474 12.7768 16.5558 14.0978L17.6313 22.204C17.7086 22.7868 17.0782 23.2008 16.5741 22.8983L12.2548 20.3068L7.93549 22.8983C7.43133 23.2008 6.8009 22.7867 6.87831 22.2039L7.95487 14.0986V14.0986ZM9.26907 14.8687L8.46201 20.9449L11.8936 18.886C12.1159 18.7526 12.3937 18.7526 12.616 18.886L16.0478 20.945L15.2415 14.8682C14.3307 15.2802 13.3195 15.5096 12.2548 15.5096C11.1905 15.5096 10.1797 15.2804 9.26907 14.8687V14.8687ZM15.3582 13.2154C15.3986 13.1823 15.443 13.1535 15.4906 13.1299C17.0667 12.0817 18.1054 10.2896 18.1054 8.25479C18.1054 5.02357 15.486 2.40415 12.2548 2.40415C9.02357 2.40415 6.40415 5.02357 6.40415 8.25479C6.40415 11.486 9.02357 14.1054 12.2548 14.1054C13.3948 14.1054 14.4587 13.7794 15.3582 13.2154V13.2154Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgAward;